import React, { PureComponent } from 'react';
import StartHeader from '@client/pages/landingPage/startPage/startHeader/StartHeader';
import TheApp from '@client/pages/landingPage/startPage/theApp/TheApp';
import UserCase from '@client/pages/landingPage/startPage/userCase/UserCase';
import Sparks from '@client/pages/landingPage/startPage/sparks/Sparks';
import styles from './startPage.scss';

class StartPage extends PureComponent {
  render() {
    return (
      <div className={styles.startPage}>
        <div className={styles.startPageContent}>
          <StartHeader />
          <TheApp />
          <UserCase />
          <Sparks />
        </div>
      </div>
    );
  }
}

export default StartPage;
